import { Autocomplete, Button, Grid, TextField } from "@mui/material";
import GlobalDialogContent from "../../GlobalDialogContent";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { useDispatch, useSelector } from "react-redux";
import { SewaCategoryStoreService, SewaCategoryUpdateService } from "../../../../utils/services/sewa-master.service";
import { showSnackbar } from "../../../../redux/reducer/snackbarSlice";
import { closeDialog } from "../../../../redux/reducer/dialogSlice";
import { setModuleRefresh } from "../../../../redux/reducer/registration/RefreshSlice";
import { Send } from "@mui/icons-material";
import { Capitalize } from "../../../../utils/utils";

const AddSewaCategory = () => {
    const payload = useSelector((state: any) => state.dialog?.payload);
    const dispatch = useDispatch();

    const formik = useFormik({
        initialValues: {
            category_name: payload?.category_name || '',
            type: payload?.type || 'sewa',
            status: payload?.status || 'active',
        },
        validationSchema: Yup.object({
            category_name: Yup.string().required('Sewa is Required'),
            type: Yup.string().required('Type is Required'),
            status: Yup.string(),
        }),
        onSubmit: async (values, { setSubmitting }) => {

            const reqPayload = {
                category_name: values.category_name || payload?.name,
                status: payload?.id ? values?.status : 'active',
                type: values?.type,
                ...payload?.id && {id: payload?.id}

            };
            const apiFunction = payload?.id ? SewaCategoryUpdateService : SewaCategoryStoreService;
            const { code, message } = await apiFunction(reqPayload);
            if (code === 200) {
                dispatch(showSnackbar({ type: "success", message: message || 'Form Submitted Successfully.' }));
                dispatch(closeDialog());
                dispatch(setModuleRefresh({ moduleName: 'SewaCategoryRefresh', refresh: true }));

            } else {
                dispatch(showSnackbar({ type: "error", message: message || 'Something Went Wrong!' }));
            }
            setSubmitting(false);
        }
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <GlobalDialogContent
                dialogBody={
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <TextField
                                fullWidth
                                label="Name of KPI"
                                name="category_name"
                                size="small"
                                value={formik.values.category_name}
                                onChange={formik.handleChange}
                                placeholder="Enter Category Name"
                                error={formik.touched.category_name && Boolean(formik.errors.category_name)}
                                helperText={formik.touched.category_name && Boolean(formik.errors.category_name)}
                            />
                        </Grid>
                        <Grid item xs={12} >
                            <Autocomplete
                                options={['sewa', 'sewa_dal']}
                                getOptionLabel={(option) => Capitalize(option) || ""}
                                value={formik.values?.type}
                                onChange={(e, value) => {
                                    formik.setFieldValue(
                                        'type',
                                        value || ''
                                    );
                                }}
                                disableClearable
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        label={'Select Sewa'}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                }
                dialogFooter={
                    <Button type="submit" disabled={formik.isSubmitting} variant="contained" color="primary" startIcon={<Send />} >
                        {formik.isSubmitting ? payload?.id ? "Updating..." : "Adding..." : payload?.id ? "Update Sewa Kshetras" : "Add Sewa Kshetras"}
                    </Button>
                }
            />
        </form>
    )
}

export default AddSewaCategory;